/* eslint-disable consistent-return */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { changePasswordApi } from '../../api/profileApi';
import AppButton from '../../shared/components/app-button/AppButton';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppLoading from '../../shared/components/app-loading/AppLoading';

function ChangePassword({ onHide }) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePassword = async () => {
    if (oldPassword === '' || newPassword === '' || confirmPassword === '') {
      setValidationError(true);
      return false;
    }
    if (newPassword !== confirmPassword) {
      onHide(true, {
        variant: 'error',
        title: 'Change Password',
        description: 'New password and confirm password should match.',
      });
      return false;
    }
    setIsLoading(true);
    const response = await changePasswordApi(newPassword, oldPassword);
    if (response) {
      if (response.ApiStatus) {
        if (response.ApiStatus.Status === 'OK') {
          onHide(false, {
            variant: 'success',
            title: 'Change Password',
            description: 'You have successfully changed your password',
          });
        } else {
          onHide(true, {
            variant: 'error',
            title: 'Change Password',
            description: response.ApiStatus.Message,
          });
        }
      } else if (response.Root.Status === 'OK') {
        onHide(false, {
          variant: 'success',
          title: 'Change Password',
          description: 'You have successfully changed your password',
        });
      } else {
        onHide(true, {
          variant: 'error',
          title: 'Change Password',
          description: response.Root.Message,
        });
      }
    } else {
      onHide(true, {
        variant: 'error',
        title: 'Change Password',
        description: 'Failed to change password. Please try again.',
      });
    }
    setIsLoading(false);
  };
  return (
    <>
      <AppLoading isLoading={isLoading} />
      <div>
        <div className="mb-3">
          <AppTextInput
            type="password"
            label="Old Password"
            name="oldpassword"
            errorText={validationError && 'Please enter Old password'}
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <AppTextInput
            type="password"
            label="New Password"
            name="newPassword"
            errorText={validationError && 'Please enter new password'}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <AppTextInput
            type="password"
            label="Confirm Password"
            name="confirmPassword"
            errorText={validationError && 'Please re-enter new password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <AppButton btnText="Change Password" onClick={handleChangePassword} />
      </div>
    </>
  );
}

ChangePassword.propTypes = {
  onHide: PropTypes.func.isRequired,
};

export default ChangePassword;
